import React, { FC } from 'react';
import styled from 'styled-components';
import { Input, Typography } from 'antd';
import { Checkbox } from '~/components';
import { DirectionProp } from '~/types/Direction';
import { useDirection } from '~/hooks/i18nHooks';
import { useServicesContext } from '~/controllers/ServicesContext';
import Form from '~/components/WizardForm';
import buildNamePath from '~/utils/buildNamePath';
import DigitalTravelPaymentsPdf from '../img/PDF/DigitalTravelPayments.pdf';
import DigitalBusinessPaymentsPdf from '../img/PDF/DigitalBusinessPayments.pdf';
import CorporateExecutiveCard from '../img/PDF/CorporateExecutiveCard.pdf';

interface Props extends ContainerProps {
  inputKey?: string;
  disabled?: boolean;
  hideCheckbox?: boolean;
  name: string;
  value?: string;
  longDescription?: string;
  index?: any;
  type?: any;
  productKey?: any;
}

const InitialServicesCheckBox: FC<Props> = (props) => {
  const {
    inputKey,
    name,
    withBorderBottom = true,
    disabled,
    hideCheckbox,
    value,
    longDescription,
    index,
    type,
    productKey,
  } = props;
  const pdfFiles: any = {
    businessCard: CorporateExecutiveCard,
    corporateExecutive: CorporateExecutiveCard,
    digitalBusinesspayments: DigitalBusinessPaymentsPdf,
    digitalBusinessTravel: DigitalTravelPaymentsPdf,
  };

  const dir = useDirection();
  const servicesContext = useServicesContext();
  const { Text, Link } = Typography;
  return (
    <Container className="ServiceCheckbox" withBorderBottom={withBorderBottom} hideCheckbox={hideCheckbox} dir={dir}>
      <Form.Item
        initialValue={disabled || false}
        valuePropName="checked"
        name={n(['initialProducts', index, 'enabled'])}
      >
        <Checkbox
          value={value}
          id={`service_checkbox_${inputKey}`}
          className="ServiceCheckbox-Checkbox"
          disabled={disabled || servicesContext.disableServiceSelection}
        >
          <div style={{ width: '125%' }}>
            <Typography.Title level={5}>{name}</Typography.Title>
            <p style={{ marginBottom: 0 }} className="ServiceCheckbox-text">
              {longDescription}
            </p>
            <Link style={{ marginTop: 0 }} href={pdfFiles[productKey] || ''} target="_blank">
              <p style={{ fontWeight: 500 }}> View More</p>
            </Link>
          </div>
        </Checkbox>
      </Form.Item>
      <div style={{ display: 'none' }}>
        <Form.Item initialValue={type} name={n(['initialProducts', index, 'id'])}>
          <Input style={{ display: 'hidden' }} />
        </Form.Item>
      </div>
    </Container>
  );
};
const n = buildNamePath('selectServices');
interface ContainerProps {
  hideCheckbox?: boolean;
  withBorderBottom?: boolean;
}

const Container = styled.div<ContainerProps & DirectionProp>`
  width: 35vw;
  left: 350px;
  height: 120px;
  .viewMoreTest {
    color: #e64360;
    font-family: Gotham;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
  }
  .ServiceCheckbox-text {
    color: var(--Text-Gray-100, #313136);
    width: 100%;
    font-family: Gotham;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
`;

export default InitialServicesCheckBox;
